import * as React from 'react';

const Loading = () => (
  <div className="loading hide-print">
    <div className="ball-triangle-path">
      <div className="ball-1" />
      <div className="ball-2" />
      <div className="ball-3" />
    </div>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.tsx